import React, { useEffect } from "react";
import { MeetingDetailComponent } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getMeetingDetails, updateAttendeeStatus, UpdateMeetingInGoogleCalendar, UpdateMeetingInOutlookCalendar } from "./actions";
import { alertService } from "@hedgefund/shared/src/Alert";

const MeetingDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const meetingDetail = useSelector((state) => state.meetingDetails);

  const { getMeeting } = meetingDetail || {};

  let splitId = location.search.split("?appointmentId=");
  const appointmentID = splitId[1];

  useEffect(() => {
    if (appointmentID) {
      dispatch(getMeetingDetails(appointmentID));
    }
  }, []);
  const onSuccess=()=> {
    alertService.success("Attendee Status Updated Successfully." , {autoClose : true});
  }
  const updateMeetingInGoogle =(values) =>{
    dispatch(UpdateMeetingInGoogleCalendar(values, onSuccessAlert));
  }

  const updateMeetingInOutlook =(values) =>{
    dispatch(UpdateMeetingInOutlookCalendar(values, onSuccessAlert));
  }

  const onSuccessAlert = () => {
    alertService.success(`Update Event in Calendar Succesffuly.`, { autoClose : true});
  }
  const updateStatusAppointmentAttendee=(values)=>{
    dispatch(updateAttendeeStatus(values , onSuccess));
  }

  return (
    <MeetingDetailComponent getMeeting={getMeeting} portal={"hedgefund"}
     updateAttendeeStatus = {updateStatusAppointmentAttendee}
     updateMeetingInGoogle={updateMeetingInGoogle}
     updateMeetingInOutlook = {updateMeetingInOutlook} />
  );
};

export default MeetingDetail;
